import React, { useEffect, useMemo, useState } from 'react';
import { Box, Button, Checkbox, FormControlLabel, InputBase, makeStyles, Typography } from '@material-ui/core';
import _ from 'lodash';
import { i18n } from '../../../../language';
import { systemAPI } from '../../../../apis';
import DiaLog from '../../../../components/Dialog';
import { CloseIcon } from '../../../../components/Icon';
import { getArrayRandomKey } from '../../../../utils';
import { alertMsg } from '../../../../apis/commlogic';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      // width: '80%',
      // height: '100%',
      display: 'flex',
      justifyContent: 'center',
      background: 'transparent',
      boxShadow: 'unset',
    },
  },
  dialogCancel: {
    textTransform: 'capitalize',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    backgroundColor: '#eff6ff',
    color: '#538fff',
    fontWeight: '500',
    borderRadius: '0.625rem',
    border: '0.12rem solid #538fff',
    width: '12.5rem',
    height: '3rem',
    marginRight: '1.25rem',
    '&:hover': {
      backgroundColor: '#eff6ff',
    },
    '&:disabled': {
      backgroundColor: '#c0c6cb !important',
      color: '#ffffff !important',
    },
  },
  checkBox: {
    marginLeft: '0rem',
    marginRight: '0rem',
    '& .MuiButtonBase-root': {
      padding: '0',
      paddingRight: '0.4rem',
    },
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  inputBase: ({ error }) => ({
    border: error ? 'solid 1px #f44336' : 'solid 1px #e4e7eb',
    borderRadius: '10px',
    height: '3.5rem',
    width: '24.5rem',
    padding: '0 1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  }),
  title: {
    fontSize: '1.142rem',
    fontWeight: 700,
    fontFamily: 'NotoSans-Medium',
    color: '#2E4469',
    marginBottom: '0.5rem',
  },
  containerBox: ({ color }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '0.875rem 1.142rem',
    border: '1px solid #E4E7EB',
    borderRadius: '0.625rem',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.312rem',
      height: '100%',
      backgroundColor: color,
      zIndex: '99',
    },
  }),
  roomTypeNameBox: {
    width: '10rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  roomName: {
    fontSize: '1rem',
    fontWeight: 600,
    fontFamily: 'NotoSans-Medium',
    color: '#2E4469',
  },
  flexBox: {
    display: 'flex',
    gridGap: '0.8rem',
    flexWrap: 'wrap',
  },
  staff: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.875rem 1.142rem',
    // width: '12rem',
    border: '1px solid #E4E7EB',
    borderRadius: '0.714rem',
    gridGap: '0.875rem',
  },
  closeIcon: {
    cursor: 'pointer',
    fontSize: '1rem',
    color: '#2E4469',
  },
  staffNameBox: {
    width: '12rem',
    // overflow: 'hidden',
  },
}));

const RoomTypeItem = ({ roomTypeItem, selectedRoom, handleAddRoleGroup }) => {
  const classes = useStyles({ color: roomTypeItem?.color });

  return (
    <Box className={classes.containerBox}>
      <FormControlLabel
        id="bed_transferpop_on_oxygen"
        control={<Checkbox />}
        label={
          <Box className={classes.roomTypeNameBox} title={roomTypeItem?.name}>
            {roomTypeItem?.name}
          </Box>
        }
        className={classes.checkBox}
        checked={_.some(selectedRoom, (item) => item?.value === roomTypeItem?.value)}
        onChange={(event) => handleAddRoleGroup({ roomTypeItem, isChecked: event.target.checked })}
      />
    </Box>
  );
};

const StaffItem = ({ staffItem, selectedStaff, handleAddStaff }) => {
  const classes = useStyles({ color: staffItem?.color });

  return (
    <Box className={classes.containerBox}>
      <FormControlLabel
        id = 'ehd_staff_item'
        control={<Checkbox />}
        label={
          <Box className={classes.staffNameBox} title={staffItem?.staffName}>
            {staffItem?.staffName}
          </Box>
        }
        className={classes.checkBox}
        checked={_.some(selectedStaff, (item) => item?.corpId === staffItem?.corpId)}
        onChange={() => handleAddStaff(staffItem)}
      />
    </Box>
  );
};

export default function IndividualUserDialog({
  open,
  closePop,
  roomTypeList,
  staffList,
  handleConfirm,
  individualUsers,
  notifyParam = null,
}) {
  const classes = useStyles();
  const [selectedRoom, setSelectedRoom] = useState(roomTypeList);
  const [selectedStaff, setSelectedStaff] = useState(staffList);
  const [staffCorpId, setStaffCorpId] = useState('');
  const otherStaff = useMemo(() => _.filter(selectedStaff, (item) => item?.type === 'OTHER'), [selectedStaff]);
  const isNotify = notifyParam !== null;

  const verifySystemUser = async () => {
    try {
      const { result } = await systemAPI.verifySystemUserRequest([
        {
          corpId: staffCorpId,
        },
      ]);
      const currentStaff = result?.[0] ?? null;
      if (currentStaff && currentStaff?.displayName) {
        handleAddStaff({
          ...currentStaff,
          staffName: currentStaff?.displayName,
          type: 'OTHER',
        });
        setStaffCorpId('');
      } else {
        alertMsg(i18n.t('EHANDOVER_CANNOT_FOUND_STAFF'), _.uniqueId('error_'), 'error');
      }
    } catch (error) {}
  };

  const onKeyDownHandler = (event) => {
    if ((event.code === 'Enter' || event.code === 'NumpadEnter') && staffCorpId) {
      verifySystemUser();
    }
  };

  const handleRemoveOtherStaff = (corpId) => {
    const newStaffList = _.filter(selectedStaff, (item) => item?.corpId !== corpId);
    setSelectedStaff(newStaffList);
    if (isNotify) {
      updateBaseOnSendToChecked({ roomList: selectedRoom, staffList: newStaffList });
    }
  };

  // 如果是notify的popup,判断roomTypeList和staffList是否都跟sendTo一样,一样就勾上baseOnSendTo
  const updateBaseOnSendToChecked = ({ roomList, staffList }) => {
    if (!isNotify) return;

    const checkEqual = (arr1, arr2) => {
      const sorted1 = _.sortBy(arr1 || [], [(o) => o.value || o.corpId]);
      const sorted2 = _.sortBy(arr2 || [], [(o) => o.value || o.corpId]);
      return _.isEqual(sorted1, sorted2);
    };
    const isRoomEqual = checkEqual(roomList, notifyParam?.sendToRoomTypeList);
    const isStaffEqual = checkEqual(staffList, notifyParam?.sendToStaffList);
    if (!isRoomEqual || !isStaffEqual) {
      notifyParam?.setNotifyBaseOnSendTo(false);
    }
    // notifyParam?.setNotifyBaseOnSendTo(isRoomEqual && isStaffEqual);
  };

  const handleAddRoleGroup = ({ roomTypeItem, isChecked }) => {
    let newRoomTypeList = [];
    if (isChecked) {
      newRoomTypeList = [...selectedRoom, roomTypeItem];
    } else {
      newRoomTypeList = _.filter(selectedRoom, (item) => item?.value !== roomTypeItem?.value);
    }
    setSelectedRoom(newRoomTypeList);

    if (isNotify) {
      updateBaseOnSendToChecked({ roomList: newRoomTypeList, staffList: selectedStaff });
    }
  };

  const handleAddStaff = (staffItem) => {
    let newStaffList = [];
    if (_.some(selectedStaff, (item) => item?.corpId === staffItem?.corpId)) {
      newStaffList = _.filter(selectedStaff, (item) => item?.corpId !== staffItem?.corpId);
    } else {
      newStaffList = [...selectedStaff, staffItem];
    }
    setSelectedStaff(newStaffList);

    if (isNotify) {
      updateBaseOnSendToChecked({ roomList: selectedRoom, staffList: newStaffList });
    }
  };

  const handleCleanAll = () => {
    setSelectedRoom([]);
    setSelectedStaff([]);
    setStaffCorpId('');
    isNotify && notifyParam?.setNotifyBaseOnSendTo(false);
  };

  const handleOnClickBaseOnSendTo = (event) => {
    const isChecked = event.target.checked;
    notifyParam?.setNotifyBaseOnSendTo(isChecked);
    if (isChecked) {
      setSelectedRoom(notifyParam?.sendToRoomTypeList ?? []);
      setSelectedStaff(notifyParam?.sendToStaffList ?? []);
    } else {
      setSelectedRoom([]);
      setSelectedStaff([]);
    }
  };

  return (
    <DiaLog
      handleClose={closePop}
      handleCancel={closePop}
      handleConfirm={() => handleConfirm({ selectedRoom, selectedStaff, isNotify })}
      title={isNotify ? i18n.t('EHANDOVER_NOTIFY_POPUP_TITLE') : i18n.t('EHANDOVER_SEND_TO')}
      cancel={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_CANCEL')}
      confirm={i18n.t('EHANDOVER_TASKITEM_CONFIRM')}
      dialogfootStyle={{ marginTop: '1rem' }}
      open={open}
      width="100%"
      maxWidth="70%"
      className={classes.dialog}
      footerButtonList={[
        <Button
          id="individualDialog_clean_button_id"
          className={classes.dialogCancel}
          onClick={handleCleanAll}
          key={getArrayRandomKey(1, 'individualUserDialog_btn')}
        >
          {i18n.t('EHANDOVER_CLEAN_ALL')}
        </Button>,
      ]}
      dialogContentStyle={{ overflowY: 'auto' }}
    >
      <Box display="flex" flexDirection="column" gridGap="2rem">
        {isNotify && (
          <FormControlLabel
            id="bed_transferpop_on_oxygen"
            control={<Checkbox />}
            label={i18n.t('EHANDOVER_BASE_ON_SEND_TO')}
            className={classes.checkBox}
            checked={notifyParam?.notifyBaseOnSendTo}
            onChange={handleOnClickBaseOnSendTo}
          />
        )}

        <Box>
          <Typography className={classes.title}>{i18n.t('EHANDOVER_DEFAULT_GROUP')}</Typography>
          <Box className={classes.flexBox}>
            {_.map(individualUsers?.roomTypeList, (roomTypeItem, index) => (
              <RoomTypeItem
                key={getArrayRandomKey(index, 'room_list')}
                roomTypeItem={roomTypeItem}
                selectedRoom={selectedRoom}
                handleAddRoleGroup={handleAddRoleGroup}
              />
            ))}
          </Box>
        </Box>

        <Box>
          <Typography className={classes.title}>{i18n.t('EHANDOVER_SEND_TO_INDIVIDUAL')}</Typography>
          <Box className={classes.flexBox}>
            {_.map(individualUsers?.staffList, (staffItem, index) => (
              <StaffItem
                key={getArrayRandomKey(index, 'staff_list')}
                staffItem={staffItem}
                selectedStaff={selectedStaff}
                handleAddStaff={handleAddStaff}
              />
            ))}
          </Box>
        </Box>

        <Box>
          <Typography className={classes.title}>{i18n.t('EHANDOVER_OTHER_STAFFS')}</Typography>
          <InputBase
            id="ehandover_other_staff"
            className={classes.inputBase}
            placeholder={i18n.t('EHANDOVER_TYPE_CORP_ID')}
            value={staffCorpId}
            onKeyDown={onKeyDownHandler}
            onChange={(event) => {
              setStaffCorpId(event.target.value);
            }}
            style={{ width: '30%', marginBottom: '1rem' }}
          />
          <Box className={classes.flexBox}>
            {_.map(otherStaff, (staffItem, index) => (
              <Box key={getArrayRandomKey(index, 'other_staff_list')} className={classes.staff}>
                <Typography className={classes.roomName}>{staffItem?.staffName}</Typography>
                <CloseIcon className={classes.closeIcon} onClick={() => handleRemoveOtherStaff(staffItem?.corpId)} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </DiaLog>
  );
}
